import { ReactElement } from 'react'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'
import { Accordion } from '@/components/enlayouts/Ir/Mpocket/Accordion'

import { useMpocketScript } from '@/hooks/useMpocketScript'

export const MeetingPage = () => {
  useMpocketScript('//irpocket.com/141A/irpocket/config-utils-main_en.js')
  // useMpocketScript('//irpocket.com/5882/irpocket/config-utils-main_en.js')
  return (
    <Layout>
      <SectionTitle
        color="normal"
        enTitleText="Shareholder's Meeting"
        subTitleText=""
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <Accordion
        id="irp-library-category5"
        className="irp-library-category irp-library-category-5"
      />
    </Layout>
  )
}

MeetingPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir' },
    { name: 'Stock Information', path: '/en/ir/stock' },
    { name: 'Shareholder\'s Meeting', path: '' },
  ]

  return (
    <>
      <Head
        title="Shareholder's Meeting"
        description="Notice of convocation of general meetings of shareholders, notice of resolutions, etc."
        ogp={{ url: 'en/ir/stock/meeting' }}
      />
      <TitleLayout
        title="Investors Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
